<template>
	<section class="app-container app-mylocations bg--secondary">
		<div class="container">
			<div v-if="!loading_user && current_user">
				<h1>My Locations</h1>
				<div class="row">
					<div class="col-md-6">
						<div class="feature feature-1 boxed boxed--border">
							<h5>Favorite Locations</h5>
							<table class="table">
								<tr class="hover-highlight" v-for="favorite in current_user.profile.favorite_locations">
									<td>
										<router-link :to="{ path: '/data/records/', query: { filterqs: '|locations:' + favorite.id }}">
											{{favorite.display_name}}
										</router-link>
									</td>
									<td class="nobr">
										<button class="btn btn-danger btn-tls" data-tooltip="remove from favorites" @click="removeFavorite(favorite)"><i class="fa fa-minus"></i></button>
										<button class="btn btn-tls" data-tooltip="edit location" @click="editFavorite(favorite)"><i class="fa fa-edit"></i></button>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="col-md-6">
						<div class="feature feature-1 boxed boxed--border">
							<h5>Other Locations</h5>
							<table class="table">
								<tr v-if="notAFavorite(location)" class="hover-highlight" v-for="location, index in current_user.profile.locations">
									<td>
										<router-link :to="{ path: '/data/records/', query: { filterqs: '|locations:' + location.id }}">
											<span class="notranslate" translate="no">{{location.display_name}}</span>
										</router-link>
									</td>
									<td class="nobr">
										<button class="btn btn-success btn-tls" data-tooltip="add to favorites" @click="addFavorite(location)"><i class="fa fa-heart"></i></button>
										<button class="btn btn-tls" data-tooltip="edit location" @click="editFavorite(location)"><i class="fa fa-edit"></i></button>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
				<LocationEditModal 
					uniqueID="locationEditModal" 
					ref="locationEditModal" 
					@saved="reload"
					>
					</LocationEditModal>
			</div>
			<div v-else-if="!loading_user" class="alert">
				<div class="alert__body">
					<span>Please login to view your locations.</span>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import global_data from '../../main';
export default {
	name: 'MyLocations',
	metaInfo: {
      title: 'My Locations',
    },
	data: function(){
		return {
			loading_user: true,
			current_user: null,
		};
	},
	mounted(){
		var self = this;
		global_data.$on("user_changed", function(new_user){
			self.reload();
		});
	},
	methods:{
		reload:function(){
			var self = this;
			self.GetAPIUser(function(user){
				self.current_user = user;
				self.loading_user = false;
			}, true, true);
		},
		editFavorite(location){
			 this.$refs.locationEditModal.showLocation(location.id)
		},
		addFavorite(location){
			var self = this;
			this.API({
				endpoint: 'user/profile/favorite-locations',
				isPost:true,
				postData: {
					id:location.id
				},
				funcThen: function(response){
					self.reload();
				},
				funcCatch: function(error){
				},
			});
		},
		notAFavorite(location){
			var found = this.current_user.profile.favorite_locations.findIndex(l => l.id == location.id);
			return found < 0;
		},
		removeFavorite(favorite){
			if (!confirm("Are you sure you want to remove this location from your favorites?")) {
				return;
			}
			var self = this;
			this.API({
				endpoint: 'user/profile/favorite-locations/' + favorite.id,
				isDelete:true,
				funcThen: function(response){
					self.reload();
				},
				funcCatch: function(error){
				},
			});
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/MyLocations.vue